exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.datetime {\n    display:inline-block;\n    width:800px;\n}\n.date {\n    float:left;\n    width: 300px;\n}\n.count {\n    float:left;\n    width:100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-371c5b9a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/datetime.vue
// module id = 805
// module chunks = 0